var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.445 8.571c-.788.054-1.201.828-.773 1.46a125.62 125.62 0 0 0 1.938 2.778c.492.684 1.31.664 1.794-.025.34-.484.68-.969 1.017-1.454.308-.441.626-.877.917-1.328.406-.63.01-1.37-.76-1.432-.202-.016-.406-.008-.61-.01H7.5v-.289c0-.83-.02-1.66.006-2.49.02-.602-.429-.05-.994-.052-.584-.003-1.023-.539-1.006.042.025.837.007 1.675.007 2.512v.285c-.382 0-.727-.02-1.068.003zm2.87-8.57v.246c.006.964-.015 1.93.024 2.893.04.978 1.058 1.892 2.147 1.928 1.082.036 2.167.018 3.25.023H13v.187c0 2.832.001 5.663-.001 8.495-.001 1.076-.784 1.948-1.951 2.175a2.885 2.885 0 0 1-.547.05c-2.668.002-5.336.003-8.005 0-1.415 0-2.494-.963-2.494-2.227-.003-3.848-.003-7.695 0-11.543C.002.97 1.077.005 2.478.002 4.024-.002 5.57 0 7.118 0h.197z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default ForwardRef;